import { AccountAdminDetailsEditConfiguration, CompanyCategoryType } from './company-query-configuration';


export const InternationalDistributorConfig = {
    configType: CompanyCategoryType.INTERNATIONAL_DISTRIBUTOR,
    association: {
        associatedDistributor: false,
        associatedContact: true,
        associatedDealer: true,
        addContact: false
    },
    services: {},
    formConfig: {
        companyName: {
            view: true,
            edit: true
        },
        companyType: { edit: false },
        companyUrl: {
            view: true,
            edit: true
        },
        shipToNumber: {
            view: true,
            edit: true
        },
        soldTo: {
            view: true,
            edit: false
        },
        parentCompany: {
            view: true,
            edit: true
        },
        services: {
            view: true,
            edit: true
        },
        payer: {
            view: true,
            edit: true
        },
        nationalAccountNumber: {
            view: true,
            edit: true
        },
        priceList: {
            view: true,
            edit: true
        },
        priceGroup: {
            view: true,
            edit: true
        },
        isPrimary: {
            view: true,
            edit: true
        },
        isAssignable: {
            view: true,
            edit: true
        },
        address1: {
            view: true,
            edit: true
        },
        address2: {
            view: true,
            edit: true
        },
        country: {
            view: true,
            edit: true
        },
        state: {
            view: true,
            edit: true
        },
        city: {
            view: true,
            edit: true
        },
        postalCode: {
            view: true,
            edit: true
        },
        phone: {
            view: true,
            edit: true
        },
        mobile: {
            view: true,
            edit: true
        },
        tollFree: {
            view: true,
            edit: true
        },
        fax: {
            view: true,
            edit: true
        },
        email: {
            view: true,
            edit: true
        },
        rsm: {
            view: true,
            edit: true
        },
        prsm: {
            view: true,
            edit: true
        },
        accountManager: {
            view: true,
            edit: true
        },
        partAccountManager: {
            view: true,
            edit: true
        },
        tsm: {
            view: true,
            edit: true
        },
        pricingAnalyst: {
            view: true,
            edit: true
        },
        legalEntity: {
            view: true,
            edit: true
        },
        divRegNumber: {
            view: true,
            edit: true
        },
        searchRadius: {
            view: true,
            edit: true
        },
        ownership: { view: false },
        showOnDistributorLocator: {
            view: true,
            edit: true
        },
        latitude: {
            view: true,
            edit: true
        },
        longitude: {
            view: true,
            edit: true
        },
        locatorName: {
            view: true,
            edit: true
        },
        notes: {
            view: true,
            edit: true
        },
        brands: {
            view: true,
            edit: true
        }
    },
    managerInformation: {
        show: true,
        partRSM: { view: true },
        partAM: { view: true }
    },
    addBrands: true
} as AccountAdminDetailsEditConfiguration;
